/* eslint-disable indent,no-undef */
import * as types from 'store/mutation-types'
import api from 'store/api'
import Vue from 'vue'

const _isFalsy = val =>
  _.isNil(val) || _.isEmpty(val) || val == 0 || val === false

const _isValid = val => !_isFalsy(val)

const requestCancel = {
  token: Vue.axios.CancelToken,
  source: null
}

const state = {
  paginatedList: [],
  searchFilters: {
    currentPage: 0,
    distribution_methods: [],
    agencies: []
  },
  catalog_dom: [],
  catalog_lld: [],
  catalog_pon: [],
  catalog_inb: [],
  userAgencies: [],
  offers: [],
  uid: 0,
  requestCancel,
  cartOwner: {}
}

const mutations = {

  [types.CATALOG_DOM_RECEIVED](state, payload) {
    state.catalog_dom = [].concat(payload)
  },

  [types.CATALOG_LLD_RECEIVED](state, payload) {
    state.catalog_lld = [].concat(payload)
  },

  [types.CATALOG_PON_RECEIVED](state, payload) {
    state.catalog_pon = [].concat(payload)
  },

  [types.CATALOG_INB_RECEIVED](state, payload) {
    state.catalog_inb = [].concat(payload)
  },

  [types.FILTER_CHANGED](state, payload) {
    state.searchFilters = _.assign({}, state.searchFilters, payload)
    state.catalog_dom = []
    state.catalog_pon = []
    state.catalog_lld = []
    state.catalog_inb = []
  },

  [types.REQUEST_TOKEN_SOURCE_CHANGED](state, source) {
    state.requestCancel.source = source
  },

  [types.CART_GET_OWNER_RECEIVED](state, owner) {
    state.cartOwner = owner
  },

  [types.CART_OFFER_INFO_RECEIVED](state, payload) {
    if (undefined == _.find(state.offers, (offer) => offer.id == payload.id))
      state.offers.push(payload)
    else {
      console.log("offer infos already got")
    }
  }

}

const actions = {

  updateFilters({ dispatch, commit, state }, filter) {
    commit(types.FILTER_CHANGED, filter)
    if (filter)
    // console.warn(filter)
    {
      if (state.catalog_dom.length == 0)
        dispatch('fetchCatalog', { 
          distribution_methods: [1], 
          agencies: [], 
          archived: 0,
          commit: types.CATALOG_DOM_RECEIVED 
        })

      if (state.catalog_lld.length == 0)
        dispatch('fetchCatalog', { 
          distribution_methods: [2], 
          agencies: [], 
          archived: 0,
          commit: types.CATALOG_LLD_RECEIVED 
        })

      // if (state.catalog_pon.length == 0)
      //   dispatch('fetchCatalog', { 
      //     distribution_methods: [4], 
      //     agencies: [], 
      //     archived: 0,
      //     commit: types.CATALOG_PON_RECEIVED 
      //   })

      // if (filter.agencies.length && state.catalog_inb.length == 0) {
      //   dispatch('fetchCatalog', {
      //     distribution_methods: [3],
      //     agencies: filter.agencies, 
      //     archived: 0,
      //     commit: types.CATALOG_INB_RECEIVED
      //   })
      // }
    }
  },

  fetchCatalog({ commit, getters }, params) {
    // console.info("Fetching Catalog datas " + params.commit)
    return (
      api.fetchCatalog({ 
        distribution_methods: params.distribution_methods, 
        agencies: params.agencies,
        archived: params.archived,
      })
      .then(response => commit(params.commit, response.data.offers)
    ))
  },

  assignToProspect({ commit }, { customer_id, cart_id }) {
    return api.setOwnerForCart(cart_id, {
      customer_id,
      owner_type: 'customer'
    })
  },

  getCartOwner({ commit }, cart_id) {
    return api.getOwnerForCart(cart_id)
  },

  get_full_offer_infos({ commit }, offer_id) {
    return api.fetchOfferById(offer_id)
      .then((response) => commit(types.CART_OFFER_INFO_RECEIVED, response.data.offer))
      .catch((error) => console.warn(error))
  },

}

const getters = {

  userAgenciesIdList(state, getters, rootState) {
    return _.map(
      rootState.user.agencies,
      (agency) => String(agency.id)
    )
  },

  selectAgenciesList(state, getters, rootState) {
    return _.chain(rootState.agencies)
      .filter(['archived', false])
      .map(
      (agency) => ({
        id: agency.id,
        text: agency.display_name
      })
      ).value()
  },

  normalizedSearchFilters(state) {
    return _.pickBy(
      state.searchFilters,
      _isValid
    )
  },

  catalog_dom(state, getters, params) {
    return (state.catalog_dom)
  },

  catalog_pon(state, getters, params) {
    return (state.catalog_pon)
  },

  catalog_lld(state, getters, params) {
    return (state.catalog_lld)
  },

  catalog_inb(state, getters, params) {
    return (state.catalog_inb)
  },


}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./client/store/modules/catalog.js